import React, { Component } from 'react';
import './ValueSetSidebar.css';
import { QueryVSContext } from '../contexts/QueryVSContext';
import StatusFilter from '../Filters/StatusFilter';
import FilterSummary from '../Filters/FilterSummary';
import TitleFilter from '../Filters/TitleFilter';
import Button from '@material-ui/core/Button';
import TagFilter from '../Filters/TagFilter';

class ValueSetSidebar extends Component {
	static contextType = QueryVSContext;

	handleClick() {
		document.getElementById('valueSetBody__id').scroll({ top: 0, behavior: 'auto' });
	}

	render() {
		const { bundle, } = this.context;

		return (
			<QueryVSContext.Consumer>
				{(queryVSContext) => (
					<div className="valueSetSidebar">
						<div className="valueSetSidebar__filters">
							<FilterSummary
								count={String((bundle.total === null || bundle.total === undefined) ? "0" : bundle.total)}
								type="Value Sets" />
							<StatusFilter />
							<TitleFilter />
							<TagFilter />
							<Button
								variant="contained"
								size="small"
								color="primary"
								onClick={(x) => {
									this.handleClick();
									queryVSContext.getData();
								}}
								className="filter__button"
							>
								Filter Data
					</Button>
						</div>
					</div>
				)}
			</QueryVSContext.Consumer>
		);
	}
}

export default ValueSetSidebar;
